var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stuContact A4Container flexCloumnCenter pageBreak_no"},[_c('div',{staticClass:"form"},[_c('div',{staticClass:"table",staticStyle:{"height":"100%"}},[_c('el-image',{staticStyle:{"width":"100%","height":"100%"},attrs:{"src":_vm.info.zf_url,"alt":"","fit":"contain"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }